import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 20">
      <g fill="none" fillRule="evenodd">
        <path fill="#F19239" d="M0-.14h16v20l-8.19-3.184L0 19.86z" />
        <path
          fill="#FFF"
          d="M7.728 10.683 4.79 12.228l.562-3.272-2.378-2.318 3.286-.477 1.47-2.978 1.469 2.978 3.286.477-2.378 2.318.561 3.272z"
        />
      </g>
    </svg>
  )
}
const SignIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
SignIcon.defaultProps = {
  width: 12,
  height: 12,
  fill: '#F19239',
}
// 参数类型
SignIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default SignIcon
